<div class="row">
  <div class="col-9"></div>
  <div class="col-3" (click)="closeDialog()" style="text-align: right;">
    <i class="material-icons" style="cursor: pointer; font-size: 28px;">
      cancel
    </i>
  </div>
</div>
<div class="row">
  <div class="col">
    The follwing route has exceed limit of tray. Adjust and close it manually
  </div>
</div>
<div class="row" *ngFor="let route of route_list">
  <div class="col">
    {{route['name']}}
  </div>
</div>
